import React from "react";
import Breadcrumb from "../../../../components/Breadcrumb";
import MasterLayout from "../../../../masterLayout/MasterLayout";
import CompletedBooking from "./CompletedBookings";

const CompletedLayout = () => {
  return (
    <MasterLayout>
      <Breadcrumb title="Completed Slots" />
      <CompletedBooking status={4} />
    </MasterLayout>
  );
};

export default CompletedLayout;
